const _excluded = ["file", "chunkSize", "highlight", "onViewed"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import "core-js/modules/es.array.iterator.js";
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { useFileReaderText } from "../../../../hooks";
import { ViewChunkPlainText } from "./view-chunk-plain-text.component";
import { ViewerControlButtonDownload, ViewerControlsBox } from "../../controls";
import { ViewerArchiveContainer, ViewerDocumentContainer, ViewerControlsContainer } from "../../container";
import { ViewArchiveInfoLoadingIcon } from "../../status";
import "./view-plain-text.style.scss";

// TODO implement onViewed callback

export const ViewPlainText = props => {
  const {
      file,
      chunkSize = 50000,
      highlight = {
        enabled: true
      },
      onViewed
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  const [loading, setLoading] = React.useState(true);
  const {
    text
  } = useFileReaderText(file);
  React.useEffect(() => {
    if (text) {
      setLoading(false);
    }
  }, [text]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ViewerArchiveContainer, {
    className: "view-text-container"
  }, /*#__PURE__*/React.createElement(ViewerControlsContainer, {
    className: "view-text-tools"
  }, /*#__PURE__*/React.createElement(ViewerControlsBox, null, /*#__PURE__*/React.createElement(ViewerControlButtonDownload, {
    archive: {
      file
    },
    name: file.name
  }))), /*#__PURE__*/React.createElement(ViewerDocumentContainer, {
    className: "view-text-document"
  }, loading ? /*#__PURE__*/React.createElement(ViewArchiveInfoLoadingIcon, {
    name: file.name
  }) : /*#__PURE__*/React.createElement(React.Fragment, null, text && /*#__PURE__*/React.createElement(ViewChunkPlainText, _extends({
    text: text,
    chunkSize: chunkSize,
    highlight: highlight
  }, rest))))));
};